import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { Typography } from '@/components/Atoms';
import { LivePricesSvg } from '@/components/Svg';
import api from '../../../../api/services/achievements';
import styles from './LivePrices.module.scss';
import LivePriceModal from './LivePriceModal';

const LivePricesSection = () => {
  const [elementList, setElementList] = useState([]);
  const [isOpenLivePriceModal, setIsOpenLivePriceModal] = useState(false);
  useEffect(() => {
    api.getMaterialCommandCenter().then((res) => {
      setElementList(res.data.data);
    });
  }, []);
  return (
    <>
      <LivePriceModal visible={isOpenLivePriceModal} onClose={() => setIsOpenLivePriceModal(false)} />
      <div className='cursor-pointer overflow-hidden' onClick={() => setIsOpenLivePriceModal(true)}>
        <div className='w-full justify-between flex pb-2'>
          <Typography size='s16ToS12' className='text-[#979797] lg:text-[11px]' isBold>
            Live Prices
          </Typography>
          <LivePricesSvg />
        </div>
        <div className='w-full h-[1px] bg-[#4F4F4F]'></div>
        <div className={styles.boxMaterial}>
          {elementList.map((item, index) => (
            <div key={index}>
              <div className='flex flex-row justify-between items-center py-[1px] lg:pr-2 w-full '>
                <div className='flex items-center mr-1 w-full'>
                  <div className='w-[36px] lg:w-[22px] h-[36px] lg:h-[22px]'>
                    <Image src={item.image} layout='responsive' width={'22px'} height={'22px'} alt='material' />
                  </div>
                  {/* <div className='gap-2'> */}
                  <Typography size='s14ToS12' className='ml-1 lg:text-[11px] flex-nowrap'>
                    {item.name}
                  </Typography>
                  {/* <Typography size='s12ToS12'>{item.unit}</Typography> */}
                  {/* </div> */}
                </div>

                <Typography className='w-full text-[#1d9514] cursor-pointer lg:text-[11px]' Component={'p'} size='s14ToS12'>
                  {/* Buy / Trade */}
                  Coming Soon
                </Typography>
              </div>
              {index !== elementList.length - 1 && <div className='w-full h-[1px] bg-[#4F4F4F]'></div>}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default LivePricesSection;
